// extracted by mini-css-extract-plugin
export default {"topic":"BlogTab_topic__9qJNE","selected-topic":"BlogTab_selected-topic__qjguD","topic-container":"BlogTab_topic-container__74zMf","select":"BlogTab_select__YQLQP"};